import { Check } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { companyListItemAnimation } from 'components/CompanyList/animation-parameters';
import {
  CompanyListItemWrapper,
  CompanyListLabel,
  CompanyListLabelWrapper,
} from 'components/CompanyList/CompanyList.styled';
import { SiteEdge } from 'types/site';

export const SiteItem = ({
  selectedSite,
  site,
  onChange,
}: {
  selectedSite: string | undefined;
  site: SiteEdge['node'];
  onChange: (site: string) => void;
}) => {
  const handleClick = () => {
    if (site.id === selectedSite) {
      return;
    }
    onChange(site.id);
  };

  return (
    <CompanyListItemWrapper
      data-testid="company-list-item"
      tabIndex={0}
      aria-disabled={!!selectedSite && selectedSite === site.id}
      onClick={handleClick}
      whileHover={
        selectedSite && site.id === selectedSite
          ? {}
          : { backgroundColor: 'rgba(0, 151, 168, 0.10)' }
      }
      transition={{
        ease: 'easeInOut',
        duration: 0.3,
      }}
      variants={companyListItemAnimation}
    >
      <CompanyListLabelWrapper>
        <CompanyListLabel>{site.name}</CompanyListLabel>
      </CompanyListLabelWrapper>
      {!!selectedSite && selectedSite === site.id ? (
        <Check data-testid="checkmark" height={24} width={24} />
      ) : null}
    </CompanyListItemWrapper>
  );
};
